import { useEffect, useState } from 'react';
import { fetchSpaceyConfig } from '../api/spaceyConfigApi';
import defaultSpaceyIcon from '../components/Agent/constants/spaceyDefaultIcon';
import {
  DEFAULT_SPACEY_INSTRUCTION_MESSAGE_COLOR,
  DEFAULT_SPACEY_INSTRUCTION_MESSAGE_TEXT_COLOR,
  DEFAULT_SPACEY_LAUNCHER_GREETING,
} from '../components/Agent/constants/spaceyDefaults';
import { resolveSpaceyIconUrl } from '../components/Agent/utils/resolveSpaceyIconUrl';
import { useActiveCountry } from './useCountryPath';

/**
 * Per-market Spacey launcher settings (icon + floating greeting).
 */
export const useSpaceyConfig = (countryCodeOverride) => {
  const activeCountry = useActiveCountry();
  const marketCode = countryCodeOverride || activeCountry?.code || 'LK';
  const [iconSrc, setIconSrc] = useState(defaultSpaceyIcon);
  const [launcherGreeting, setLauncherGreeting] = useState(DEFAULT_SPACEY_LAUNCHER_GREETING);
  const [instructionMessageColor, setInstructionMessageColor] = useState(
    DEFAULT_SPACEY_INSTRUCTION_MESSAGE_COLOR,
  );
  const [instructionMessageTextColor, setInstructionMessageTextColor] = useState(
    DEFAULT_SPACEY_INSTRUCTION_MESSAGE_TEXT_COLOR,
  );

  useEffect(() => {
    let cancelled = false;
    setIconSrc(defaultSpaceyIcon);
    setLauncherGreeting(DEFAULT_SPACEY_LAUNCHER_GREETING);
    setInstructionMessageColor(DEFAULT_SPACEY_INSTRUCTION_MESSAGE_COLOR);
    setInstructionMessageTextColor(DEFAULT_SPACEY_INSTRUCTION_MESSAGE_TEXT_COLOR);

    fetchSpaceyConfig(marketCode).then((config) => {
      if (cancelled || !config) return;
      setIconSrc(resolveSpaceyIconUrl(config.iconUrl) || defaultSpaceyIcon);
      setLauncherGreeting(config.launcherGreeting || DEFAULT_SPACEY_LAUNCHER_GREETING);
      setInstructionMessageColor(
        config.instructionMessageColor || DEFAULT_SPACEY_INSTRUCTION_MESSAGE_COLOR,
      );
      setInstructionMessageTextColor(
        config.instructionMessageTextColor || DEFAULT_SPACEY_INSTRUCTION_MESSAGE_TEXT_COLOR,
      );
    });

    return () => {
      cancelled = true;
    };
  }, [marketCode]);

  return { iconSrc, launcherGreeting, instructionMessageColor, instructionMessageTextColor };
};

export default useSpaceyConfig;
